import pino from 'pino';
import loggerInstance from './index';

const logger: pino.Logger = loggerInstance;
export default logger;
